import { RoleTest } from '../permissions';
import { useProtected } from './useProtected';

export function useHasPermission(requiredPermissions: RoleTest): boolean {
    return useProtected({ requiredPermissions, value: true, fallback: false });
}
